import gql from 'graphql-tag';

export const getControllerNote = gql`
  query getControllerNote($noteId: String) {
    getControllerNote(noteId: $noteId) {
      category
      AORId
      AORName
      addToTurnover
      abnormalOperation
      businessUnits
      city
      contactId
      contactName
      createdAt
      county
      createdBy
      facilityName
      facilityId
      facilityUID
      falseAlarm
      id
      maop
      noteType
      phoneNumber
      pipeline
      pipelineSection
      state
      township
      updatedAt
      updater
      systemName
      entries {
        createdAt
        createdBy
        id
        note
        time
        updatedAt
        updater
        version
        controllerNotesId
      }
      calloutInitiated
      unit
      unitStatus {
        id
        name
      }
      maintenance
      facilityScadaId
      valvePosition {
        id
        name
      }
      SCADAControl {
        id
        name
      }
    }
  }
`;
